import { render, staticRenderFns } from "./WorkListPCR.vue?vue&type=template&id=1cd51314"
import script from "./WorkListPCR.vue?vue&type=script&lang=js"
export * from "./WorkListPCR.vue?vue&type=script&lang=js"
import style0 from "./WorkListPCR.vue?vue&type=style&index=0&id=1cd51314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports